let data = {
  development: {
    api: 'http://172.17.12.236:9001'
  },
  test: {
    api: 'http://172.17.12.236:9001'
  },
  release: {
    // api: 'http://172.17.12.236:9001'
    api: 'https://mrgateway.qx.com'
  },
  master: {
    api: 'http://172.17.12.236:9001'
  }
}

module.exports = data;



// WEBPACK FOOTER //
// ./src/assets/js/https.js